// These schemas should match their corresponding DB model in @performyard/models
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get AutoflowTask () {
        return AutoflowTask;
    },
    get AutoflowTaskResponse () {
        return AutoflowTaskResponse;
    }
});
const _zod = require("zod");
const _taskconsole = require("./task-console");
const _taskquery = require("./task-query");
const _taskreviewcycle = require("./task-review-cycle");
const _tasksurvey = require("./task-survey");
const AutoflowTask = _zod.z.discriminatedUnion("taskType", [
    _taskconsole.AutoflowTaskConsoleLog,
    _taskquery.AutoflowTaskQueryUser,
    _taskquery.AutoflowTaskQueryCompany,
    _taskreviewcycle.AutoflowTaskReviewCycleAddUsers,
    _taskreviewcycle.AutoflowTaskReviewCycleCheckCompletion,
    _taskreviewcycle.AutoflowTaskReviewCycleExcludeExistingSubjects,
    _tasksurvey.AutoflowTaskSurveyOpenEmail
]);
const AutoflowTaskResponse = _zod.z.discriminatedUnion("taskType", [
    _taskconsole.AutoflowTaskConsoleLogResponse,
    _taskquery.AutoflowTaskQueryUserResponse,
    _taskquery.AutoflowTaskQueryCompanyResponse,
    _taskreviewcycle.AutoflowTaskReviewCycleAddUsersResponse,
    _taskreviewcycle.AutoflowTaskReviewCycleCheckCompletionResponse,
    _taskreviewcycle.AutoflowTaskReviewCycleExcludeExistingSubjectsResponse,
    _tasksurvey.AutoflowTaskSurveyOpenEmailResponse
]);
